import React from 'react';
import { Box, Grid } from '@mui/system';
import NCRAIIcon from './NCRAIIcon';
import { TextField, Typography } from '@mui/material';

export default function AILabelBox({ label, handleAIClick, content, aiResponse, onChange, is_rrc = false, isAIrrcOpen = null, setAIrrcOpen = null }) {
  const isLoading = aiResponse[label] === " ." || aiResponse[label] === " .." || aiResponse[label] === " ...";
  const isOpen = is_rrc ? isAIrrcOpen : true;

  return (
    <Box sx={{ width: is_rrc ? '563px' : '50%', pl: is_rrc ? '' : 2 }}>
      <Grid item xs={4}>
        {is_rrc ? (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            pt: 2,
            pb: isOpen ? 1 : '',
            cursor: "pointer"
          }}
            onClick={() => {
              if (!isOpen) {
                handleAIClick(label);
              }
              if (content?.formData?.process_root_cause_description && !isOpen) {
                setAIrrcOpen?.(!isOpen);
              }
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontSize: '14px',
                fontWeight: 400,
                color: '#2A3DBD',
                pr: 1,
              }}
            >
              Click here to show Relevant root cause
            </Typography>
          </Box>
        ) : (
          <NCRAIIcon label={label} aiResponse={aiResponse} handleAIClick={() => handleAIClick(label)} />
        )}
      </Grid>
      {(is_rrc ? isOpen : true) && (
        < Grid item xs={8}>
          <TextField
            multiline
            minRows={3}
            placeholder={aiResponse[label] === '$@!' ? '' : 'AI Suggestions will appear here'}
            name="ai-suggestion"
            className="default-text ai-suggest-box"
            value={aiResponse[label] === '$@!' ? '' : aiResponse[label]}
            sx={{
              fontSize: isLoading ? '28px' : '26px',
              lineHeight: isLoading ? '18px' : 'inherit',
              width: "100%",
              maxWidth: "563px",
              backgroundColor: (aiResponse?.[label] === '$@!' || !!aiResponse?.[label]) ? 'rgba(235, 235, 235, 1)' : 'transparent',
              '&:hover textarea': {
                cursor: (aiResponse?.[label] && !is_rrc) ? 'pointer' : 'default',
                color: (aiResponse?.[label] && !is_rrc) ? 'rgba(42, 61, 189, 1) !Important' : '',
                textDecoration: (aiResponse?.[label] && !is_rrc) ? 'underline' : 'none'
              },
              caretColor: 'transparent',
            }}
            onClick={() => {
              if (aiResponse?.[label]) {
                onChange({ [label]: aiResponse[label] });
              }
            }}
          />
        </Grid>
      )}
    </Box>
  );
}
